module.exports = __webpack_public_path__ + "static/media/DELIRIUM.bcac3299.png";